import { alcohol, apple, avocado, bananas, beer, cake, chicken, chips, cocacola, coffee, cookie, cupcake, donut, energy, fish, fries, grape, icecream, jelly, juice, mashed, milkshake, nachos, orange, pancakes, papaya, passion, pasta, peach, pear, pizza, pork, rice, salad, steak, tea, waffles, water, watermelon, wine } from 'assets/images';
const FoodData = [
  {
    id: 1,
    quantity: 1,
    image: chicken,
    title: 'Roasted Chicken',
    price: 1600,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 2,
    quantity: 1,
    image: pizza,
    title: 'Large Pizza',
    price: 1000,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 3,
    quantity: 1,
    image: salad,
    title: 'Bowl of Salad',
    price: 400,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 4,
    quantity: 1,
    image: pork,
    title: 'Fried Pork',
    price: 500,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 5,
    quantity: 1,
    image: fish,
    title: 'Fried Fish',
    price: 400,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 6,
    quantity: 1,
    image: fries,
    title: 'French Fries',
    price: 200,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 7,
    quantity: 1,
    image: steak,
    title: 'Fried Meat',
    price: 500,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 8,
    quantity: 1,
    image: rice,
    title: 'Bowl of Rice',
    price: 150,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 9,
    quantity: 1,
    image: pasta,
    title: 'Bowl of Pasta',
    price: 100,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 10,
    quantity: 1,
    image: mashed,
    title: 'Bowl of Mashed Potatoes',
    price: 180,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 11,
    quantity: 1,
    image: cocacola,
    title: 'Bottle of Soda',
    price: 100,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 12,
    quantity: 1,
    image: juice,
    title: 'Bottle of Juice',
    price: 80,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 13,
    quantity: 1,
    image: water,
    title: 'Bottle of water',
    price: 40,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 14,
    quantity: 1,
    image: energy,
    title: 'Energy Drink',
    price: 240,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 15,
    quantity: 1,
    image: coffee,
    title: 'Coffee',
    price: 400,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 16,
    quantity: 1,
    image: tea,
    title: 'Bubble Tea',
    price: 300,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 17,
    quantity: 1,
    image: milkshake,
    title: 'Milkshake',
    price: 250,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 18,
    quantity: 1,
    image: beer,
    title: 'Can of Beer',
    price: 150,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 19,
    quantity: 1,
    image: alcohol,
    title: 'Bottle of Alcohol',
    price: 2000,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 20,
    quantity: 1,
    image: wine,
    title: 'Bottle of Wine',
    price: 3000,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 21,
    quantity: 1,
    image: bananas,
    title: 'Banana Fruit',
    price: 20,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 22,
    quantity: 1,
    image: apple,
    title: 'Apple Fruit',
    price: 50,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 23,
    quantity: 1,
    image: orange,
    title: 'Orange Fruit',
    price: 40,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 24,
    quantity: 1,
    image: pear,
    title: 'Pear Fruit',
    price: 400,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 25,
    quantity: 1,
    image: grape,
    title: 'Grape Fruit',
    price: 400,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 26,
    quantity: 1,
    image: papaya,
    title: 'Papaya Fruit',
    price: 200,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 27,
    quantity: 1,
    image: passion,
    title: 'Passion Fruit',
    price: 50,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 28,
    quantity: 1,
    image: watermelon,
    title: 'Watermelon Fruit',
    price: 200,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 29,
    quantity: 1,
    image: avocado,
    title: 'Avocado Fruit',
    price: 80,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 30,
    quantity: 1,
    image: peach,
    title: 'Peach Fruit',
    price: 40,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 31,
    quantity: 1,
    image: cake,
    title: 'Cake',
    price: 4000,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 32,
    quantity: 1,
    image: donut,
    title: 'Donut',
    price: 80,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 33,
    quantity: 1,
    image: icecream,
    title: 'Ice Cream',
    price: 400,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 34,
    quantity: 1,
    image: jelly,
    title: 'Jelly',
    price: 200,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 35,
    quantity: 1,
    image: cupcake,
    title: 'Cupcake',
    price: 40,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 36,
    quantity: 1,
    image: cookie,
    title: 'Cookie',
    price: 20,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 37,
    quantity: 1,
    image: pancakes,
    title: 'Pancake',
    price: 500,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 38,
    quantity: 1,
    image: waffles,
    title: 'Waffles',
    price: 150,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 39,
    quantity: 1,
    image: chips,
    title: 'Potato Chips',
    price: 60,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
  {
    id: 40,
    quantity: 1,
    image: nachos,
    title: 'Nachos',
    price: 280,
    description:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Etvoluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et voluptas inventore ad officia vel beatae delectus, reiciendis voluptatem porro repellat, aspernatur suscipit assumenda sit labore corrupti eveniet quis eum dolore?',
  },
];

export default FoodData;
